
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Get } from 'vuex-pathify';

import { format } from 'date-fns';
import { FulfillmentType } from '../../../types/ProductDelivery';
import { ILocalStoreJson } from '../../../types/LocalStore';
import { IProductGroupSelector } from '../../../types/Product';

import FulfillmentOptionComponent from './FulfillmentOption.vue';
import FulfillmentOptionLink from './FulfillmentOptionLink.vue';
import Icon from 'Src/js/components/Icon.vue';
import StockSubscriptionFormTrigger from './StockSubscriptionFormTrigger.vue';
import { IProductDetailProductJson } from 'JS/types/PDP';
import { ProductSubscriptionStatus } from 'JS/types/Order';

@Component({
	name: 'InStorePickup',
	components: {
		FulfillmentOptionComponent,
		FulfillmentOptionLink,
		StockSubscriptionFormTrigger,
		Icon,
	}
})
export default class InStorePickup extends Vue {
	@Prop({ type: Boolean, required: false, default: false })
	readonly loading: boolean;

	/* Computed
	============================================*/
	@Get('outOfMarket')
	readonly outOfMarket: boolean;

	@Get('localStore')
	readonly localStore: ILocalStoreJson;

	@Get('product')
	readonly product: IProductDetailProductJson;

	@Get('remainingSelectors')
	readonly remainingSelectors: IProductGroupSelector[];

	@Get('fetchingProduct')
	readonly fetchingProduct: boolean;

	@Get('selectedFulfillmentType')
	readonly selectedFulfillmentType: FulfillmentType;

	@Get('isInStockInStore')
	readonly isInStockInStore: boolean;

	@Get('isPickupDisabled')
	readonly isPickupDisabled: boolean;

	@Get('hasSelectorError')
	readonly hasSelectorError: boolean;

	@Get('hasSelectedVariant')
	readonly hasSelectedVariant: boolean;

	get pickupPromoText(): string {
		if (!!this.product.arrivalDate) {
			return "";
		}
		return "Free & Ready in an Hour!";
	}
	
	get isSelected(): boolean {
		return !this.isDisabled && this.fulfillmentOption === this.selectedFulfillmentType;
	};

	get isDisabled(): boolean {
		return this.isPickupDisabled
				|| !this.hasSelectedVariant
				|| this.fetchingProduct
				|| this.loading;
	};

	get linkToStockModalText(): string {
		return this.isInStockInStore ? 'Change Store' : 'Check Nearby Stores';
	};

	get inStoreStockMessage(): string {
		if (this.product.notCarriedInStore) return 'Not Carried';
		if (this.isInStockInStore) return this.product.activeInStorePickup ? 'In Stock' : 'Available in Store';
		return 'Out of Stock';
	};

	get stockSubscriptionFormEnabled(): boolean {
		return this.product.backInStockInfo.isProductEligible &&
				!this.isInStockInStore &&
				this.hasSelectedVariant &&
				!this.outOfMarket &&
				!this.fetchingProduct &&
				!this.product.notCarriedInStore;
	}

	get nextReminderBeforeDue(): string | null {
		if (this.product.subscriptionInfo.status === ProductSubscriptionStatus.Active && !this.product.subscriptionInfo.isDue) {
			return format(new Date(this.product.subscriptionInfo.nextReminder), "eee MM/dd");;
		}
		return null;
	}

	get deadlineDateWhileDue(): string | null {
		if (this.product.subscriptionInfo.status === ProductSubscriptionStatus.Active && this.product.subscriptionInfo.isDue) {
			return format(new Date(this.product.subscriptionInfo.deadlineDateShort), "eee MM/dd");;
		}
		return null;
	}

	/* Data
	============================================*/
	readonly fulfillmentOption: FulfillmentType = FulfillmentType.InStorePickup;
	showDrawer = true;


	/* Methods
	============================================*/

	onChange() {
		if (this.isSelected) {
			return;
		}
		this.$emit('change', this.fulfillmentOption);

		if (this.product.subscriptionInfo.status === ProductSubscriptionStatus.Active && this.product.subscriptionInfo.isDue) {
			this.$store.commit('quantity', this.product.subscriptionInfo.quantity);
		}
	}

	/* Lifecycle Hooks
	============================================*/

	created() {
		if (this.selectedFulfillmentType === FulfillmentType.InStorePickup && this.product.subscriptionInfo.status === ProductSubscriptionStatus.Active && this.product.subscriptionInfo.isDue) {
			this.$store.commit('quantity', this.product.subscriptionInfo.quantity);
		}
	}
}
